// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorElement_error__3UXMp"};